import * as React from 'react';
import { OptionsPanel } from './options-panel/options-panel';
import { PanelsProps, GroupingType } from './types';
import { sfNames, sfParameters } from './sf-names';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';

export const Operation = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation, clearValueInStore,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValidation,
    options, loadOptions } = props;

  return <AdminPaperTopPanel title={translation.operation}>
    <OptionsPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data && data.accessOperations}
      roleSelected={roleSelected}
      roleValue={roleBasedData && roleBasedData.accessOperations}
      accessData={accessData && accessData.accessOperations}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}
      formComponent={formComponent}
      formValues={formValues}
      formName={sfNames.accessOperations}
      groupingName={sfParameters.application}
      groupingType={GroupingType.Multiple}
      valueName={sfParameters.operation}
      validation={validation}
      groupingOptionsEndpoint={endpoints.applications}
      valuesOptionsEndpoint={endpoints.operations}
      groupingLabel={translation.application_or_case}
      addButtonText={translation.add_application_or_case_type_button_text}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
      useLabelOption={readOnly}
      singleStepAccess={true}
      options={options}
      loadOptions={loadOptions}
      displaySelectAll={true}
    />
  </AdminPaperTopPanel>;
};
